import { ref } from 'vue';

export function useFlipcharts(rows) {
    const flipcharts = (symbols, ids = false) => {
        if (!symbols && !ids) {
            symbols = rows.value.map(row => row.symbol).filter((symbol) => symbol !== undefined);
        }

        let route;
        if (ids !== false) {
            route = window.route('interactive-charts.flip-charts-by-id', { ids });
        } else {
            route = window.route('interactive-charts.flip-charts', { symbols });
        }

        // For smaller screens
        const width = Math.min((window.screen.availWidth * 0.8).toFixed(), 1000);
        const height = Math.min((window.screen.availHeight * 0.8).toFixed(), 850);

        window.open(route, 'FlipCharts', `resizable,status,scrollbars,width=${width},height=${height}`);
    };

    return {
        flipcharts,
    };
}
